import axios from "axios";

import { getAuthHeader } from "../headers";

// ===================================================================================
//  GET REVIEW RECORD
// ===================================================================================
export const reviewRecordIsLoading = () => {
	return {
		type: "REVIEW_RECORD_IS_LOADING"
	};
};

export const reviewRecordHasError = err => {
	return {
		type: "REVIEW_RECORD_HAS_ERROR",
		error: err
	};
};

export const reviewRecordSuccess = data => {
	return {
		type: "REVIEW_RECORD_SUCCESS",
		data
	};
};

export function getReviewRecord(id = null, isAdmin = false) {
	return (dispatch, getState) => {
		dispatch(reviewRecordIsLoading());

		// Add id of record to find if passed
		const endPoint = `review/${id}`;

		return axios
			.get(process.env.REACT_APP_API_URL + endPoint, {
				headers: getAuthHeader(getState().user, isAdmin)
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					if (response.data.message !== "") {
						dispatch(reviewRecordHasError(response.data.message));
					} else {
						dispatch(reviewRecordHasError(response.data.errors));
					}
				} else {
					dispatch(reviewRecordSuccess(response));

					// In the admin area, we will be doing specific stuff once we return this promise... so... ya
					return Promise.resolve(response);
				}
			})
			.catch(err => {
				dispatch(reviewRecordHasError(err.response.data.message));
			});
	};
}

// ===================================================================================
//  GET REVIEWS
// ===================================================================================
export const reviewsIsLoading = () => {
	return {
		type: "REVIEWS_ARE_LOADING"
	};
};

export const reviewsHasError = err => {
	return {
		type: "REVIEWS_HAS_ERROR",
		hasErrored: true,
		error: err
	};
};

export const reviewsSuccess = data => {
	return {
		type: "REVIEWS_SUCCESS",
		data
	};
};

export const reviewsResetState = () => {
	return {
		type: "REVIEWS_RESET_STATE"
	};
};

export function getReviews(id = null, isAdmin = false, num = null) {
	return (dispatch, getState) => {
		dispatch(reviewsIsLoading());
		const params = num === null ? {} : { num };

		// Add id of record to find if passed
		const endPoint = "reviews" + (id ? `/${id}` : "");

		return axios
			.get(process.env.REACT_APP_API_URL + endPoint, {
				headers: getAuthHeader(getState().user, isAdmin),
				params
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					if (response.data.message !== "") {
						dispatch(reviewsHasError(response.data.message));
					} else {
						dispatch(reviewsHasError(response.data.errors));
					}
				} else {
					dispatch(reviewsSuccess(response));
				}
			})
			.catch(err => {
				dispatch(reviewsHasError(err.response.data.message));
			});
	};
}

// ===================================================================================
//  GET REVIEWS THAT REVIEWER IS SIGNED UP FOR (ON-SITE)
// ===================================================================================
export const signedUpReviewsIsLoading = () => {
	return {
		type: "SIGNED_UP_REVIEWS_ARE_LOADING"
	};
};

export const signedUpReviewsHasError = err => {
	return {
		type: "SIGNED_UP_REVIEWS_HAS_ERROR",
		hasErrored: true,
		error: err
	};
};

export const signedUpReviewsSuccess = data => {
	return {
		type: "SIGNED_UP_REVIEWS_SUCCESS",
		data
	};
};

export function getSignedUpReviews(num = null) {
	return (dispatch, getState) => {
		dispatch(signedUpReviewsIsLoading());

		// If necessary, params will be max number of reviews requested
		const params = num === null ? {} : { num };

		// Set API endpoint
		const endPoint = "reviews/signed-up";

		return axios
			.get(process.env.REACT_APP_API_URL + endPoint, {
				headers: getAuthHeader(getState().user),
				params
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					if (response.data.message !== "") {
						dispatch(signedUpReviewsHasError(response.data.message));
					} else {
						dispatch(signedUpReviewsHasError(response.data.errors));
					}
				} else {
					return dispatch(signedUpReviewsSuccess(response));
				}
			})
			.catch(err => {
				dispatch(signedUpReviewsHasError(err.response.data.message));
			});
	};
}

// ===================================================================================
//  GET USER-RELATED REVIEWS (BY SECTORS)
// ===================================================================================
export const relatedReviewsIsLoading = () => {
	return {
		type: "RELATED_REVIEWS_ARE_LOADING"
	};
};

export const relatedReviewsHasError = err => {
	return {
		type: "RELATED_REVIEWS_HAS_ERROR",
		hasErrored: true,
		error: err
	};
};

export const relatedReviewsSuccess = data => {
	return {
		type: "RELATED_REVIEWS_SUCCESS",
		data
	};
};

export function getRelatedReviews(num = null) {
	return (dispatch, getState) => {
		dispatch(relatedReviewsIsLoading());

		// If necessary, params will be max number of reviews requested
		const params = num === null ? {} : { num };

		// Set API endpoint
		const endPoint = "reviews/related";

		return axios
			.get(process.env.REACT_APP_API_URL + endPoint, {
				headers: getAuthHeader(getState().user),
				params
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					if (response.data.message !== "") {
						dispatch(relatedReviewsHasError(response.data.message));
					} else {
						dispatch(relatedReviewsHasError(response.data.errors));
					}
				} else {
					return dispatch(relatedReviewsSuccess(response));
				}
			})
			.catch(err => {
				dispatch(relatedReviewsHasError(err.response.data.message));
			});
	};
}

// ===================================================================================
//	SPECIAL ACTION WHEN BOTH RELATED AND ALL REVIEWS ARE SUPPLIED AT ONCE
// ===================================================================================
export const reviewsRelatedAndAllSuccess = (related, all) => {
	return {
		type: "RELATED_AND_ALL_REVIEWS_SUCCESS",
		related,
		all
	};
};

// ===================================================================================
//  GET USER PAST REVIEWS (BY SECTORS)
// ===================================================================================
export const pastReviewsIsLoading = () => {
	return {
		type: "PAST_REVIEWS_ARE_LOADING"
	};
};

export const pastReviewsHasError = err => {
	return {
		type: "PAST_REVIEWS_HAS_ERROR",
		hasErrored: true,
		error: err
	};
};

export const pastReviewsSuccess = data => {
	return {
		type: "PAST_REVIEWS_SUCCESS",
		data
	};
};

export function getPastReviews(num = null) {
	return (dispatch, getState) => {
		dispatch(pastReviewsIsLoading());

		// If necessary, params will be max number of reviews requested
		const params = num === null ? {} : { num };

		// Set API endpoint
		const endPoint = "reviews/past";

		return axios
			.get(process.env.REACT_APP_API_URL + endPoint, {
				headers: getAuthHeader(getState().user),
				params
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					if (response.data.message !== "") {
						dispatch(pastReviewsHasError(response.data.message));
					} else {
						dispatch(pastReviewsHasError(response.data.errors));
					}
				} else {
					return dispatch(pastReviewsSuccess(response));
				}
			})
			.catch(err => {
				dispatch(pastReviewsHasError(err.response.data.message));
			});
	};
}

// ===================================================================================
//  GET REVIEWS GIVEN DATE RANGE (BY SITE VISIT)
// ===================================================================================
export const reviewsDateRangeIsLoading = () => {
	return {
		type: "REVIEWS_DATE_RANGE_ARE_LOADING"
	};
};

export const reviewsDateRangeError = err => {
	return {
		type: "REVIEWS_DATE_RANGE_HAS_ERROR",
		hasErrored: true,
		error: err
	};
};

export const reviewsDateRangeSuccess = data => {
	return {
		type: "REVIEWS_DATE_RANGE_SUCCESS",
		data
	};
};

export function getReviewsDateRange(date_start, date_end) {
	return (dispatch, getState) => {
		dispatch(reviewsDateRangeIsLoading());

		const data = {
			date_start,
			date_end
		};

		// Set API endpoint
		const endPoint = "reviews/date-range";

		return axios
			.post(process.env.REACT_APP_API_URL + endPoint, data, {
				headers: getAuthHeader(getState().user, true)
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					if (response.data.message !== "") {
						dispatch(reviewsDateRangeError(response.data.message));
					} else {
						dispatch(reviewsDateRangeError(response.data.errors));
					}
				} else {
					return dispatch(reviewsDateRangeSuccess(response));
				}
			})
			.catch(err => {
				dispatch(reviewsDateRangeError(err.response.data.message));
			});
	};
}

// ===================================================================================
//  DOCUMENTS
// ===================================================================================
export const updateDocuments = documents => {
	return {
		type: "UPDATE_REVIEW_DOCUMENTS",
		documents
	};
};



// WEBPACK FOOTER //
// ./src/store/actions/reviews.js